import { ApplicationWithDetails } from '../../../types';
import { SpurtDescription_eng } from './SpurtDescription';
import { SpurtInstructions_eng } from './SpurtInstructions/SpurtInstructions';
import { spurtPlans_eng } from './SpurtPlans';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Spurt_eng: ApplicationWithDetails = {
	id: `11EDF0CB38BDE6B8BE4756D61637848D`,
	name: `Spurt`,
	description: `Receive reports, analytics and notifications.`,
	descriptionHTML: SpurtDescription_eng,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/spurt/logo-1`,
	sliders: [`https://cdn.dodostatic.net/static/marketplace/spurt/slider-new-1-eng`],
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/spurt/logo-bgr`,
	conceptions: [`Dodo Pizza`, `Drinkit`, `Doner42`],
	webSiteUrl: `https://spurt.dev/`,
	supportUrl: null,
	redirectUrl: ``,
	contactEmail: `Telegram channel`,
	supportEmail: `https://t.me/+ouBXJgE4f1IzOTUy`,
	type: `Bot`,
	categories: [`Reports`, `Notifications`, `Production monitoring`],
	countries: [`All`],
	languages: [`Русский`, `English`],
	price: `Free`,
	version: `1.0`,
	developer: `Spurt.dev`,
	plans: spurtPlans_eng,
	instructions: SpurtInstructions_eng,
	details: null,
	knowledgeBase: null,
	isExternal: true,
	showInstruction: true,
	versionHistory: `https://doc.clickup.com/2699605/d/h/2jcan-21464/9934edd7f480e01/2jcan-15344`,
	goToApp: true,
};
